module.exports = __webpack_public_path__ + "static/content-04-bf1e4a5b725437378df5a2b5c275f7b5.jpg";